import { render, staticRenderFns } from "./view-details.vue?vue&type=template&id=17b996ca"
import script from "./view-details.vue?vue&type=script&lang=js"
export * from "./view-details.vue?vue&type=script&lang=js"
import style0 from "./view-details.vue?vue&type=style&index=0&id=17b996ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports